import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { baseUrlEncoder } from '../../utils/baseUrl.encoder';
import * as T_T from 'cryface';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
   components: {
      ASpaceInBetweenAnother
   }
})
export default class JustListedCard extends Vue {
   public title: string = 'JustListedCard';

   @Prop()
   public data: any;

   @Prop()
   public toPrintSingal: any;

   public displayData: any = {};

   public imageUrl: any = null;

   @Watch('data', { immediate: true, deep: true })
   public async onDataInput(val: any, oldVal: any) {
      // console.log(val);
      this.displayData = val;
      this.imageUrl = this.displayData.imageUrl;
      // const baseUrl = await baseUrlEncoder(this.displayData.image);
      // this.displayData.image = baseUrl;
   }

   @Watch('toPrintSingal', { immediate: true, deep: true })
   public async onToPrintSingal(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         if (val) {
            const baseUrl = await baseUrlEncoder(this.displayData.image);
            this.displayData.image = baseUrl;
         } else {
            this.displayData.image = this.imageUrl;
         }
      }
   }

   public navToDetail(mlsNumber: string) {
      // this.$router.push(`/listing/treb-${mlsNumber}`);
   }
}
